import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import SearchableSelect from '../../components/common/SearchableSelect';

export const PAGE_SIZES = [10, 50, 100, 500, 1000];

export default function Pagination({ meta, onPage, onPerPage }) {
  if (!meta) return null;
  const { current_page = 1, last_page = 1, total = 0, per_page = 100 } = meta;
  const pageSizes = Array.isArray(meta.per_page_options) && meta.per_page_options.length
    ? meta.per_page_options
    : PAGE_SIZES;

  const pages = [];
  const start = Math.max(1, current_page - 2);
  const end = Math.min(last_page, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const from = total === 0 ? 0 : (current_page - 1) * per_page + 1;
  const to = Math.min(current_page * per_page, total);

  return (
    <div className="pagination">
      <div className="info">
        Showing <b>{from}</b> to <b>{to}</b> of <b>{total}</b> entries
      </div>
      {onPerPage && (
        <div className="per-page" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Per page:</span>
          <div style={{ width: 90 }}>
            <SearchableSelect
              options={pageSizes}
              value={per_page}
              onChange={(v) => onPerPage(Number(v))}
              placeholder="Per page"
            />
          </div>
        </div>
      )}
      <div className="pages">
        <button
          className="page-btn"
          disabled={current_page <= 1}
          onClick={() => onPage(current_page - 1)}
        >
          <FiChevronLeft />
        </button>
        {pages.map((p) => (
          <button
            key={p}
            className={`page-btn ${p === current_page ? 'active' : ''}`}
            onClick={() => onPage(p)}
          >
            {p}
          </button>
        ))}
        <button
          className="page-btn"
          disabled={current_page >= last_page}
          onClick={() => onPage(current_page + 1)}
        >
          <FiChevronRight />
        </button>
      </div>
    </div>
  );
}